import { useState } from "react";

export function useOrg360PanelState() {
  const [contextOpen, setContextOpen] = useState(false);
  const [inspectorOpen, setInspectorOpen] = useState(false);

  return {
    contextOpen,
    inspectorOpen,
    toggleContext:   () => setContextOpen((v) => !v),
    toggleInspector: () => setInspectorOpen((v) => !v),
    openContext:     () => setContextOpen(true),
    closeContext:    () => setContextOpen(false),
    openInspector:   () => setInspectorOpen(true),
    closeInspector:  () => setInspectorOpen(false),
  };
}
